import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { OrdersService } from '../../../core/services/orders/orders.service';
import { AlertService } from '../../../core/services/alert/alert.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormDocumentsComponent } from '../form-documents/form-documents.component';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BadgeColorPipe } from '../../../core/pipe/badge-color.pipe';
import { BadgeVehiclePipe } from '../../../core/pipe/badge-vehicle.pipe';
import { BadgeClientPipe } from '../../../core/pipe/badge-client.pipe';
import { copyToClipboard as copyToClipboardUtil } from '../../../core/utils/clipboard.utils';

interface AccountData {
  reference: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}
interface ApiResponse {
  data: AccountData[];
}
@Component({
  selector: 'app-download-documents',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    FormDocumentsComponent,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    BadgeColorPipe,
    BadgeVehiclePipe,
    BadgeClientPipe,
  ],
  templateUrl: './download-documents.component.html',
  styleUrl: './download-documents.component.css',
})
export class DownloadDocumentsComponent implements OnInit {
  orderData: any;
  isLoading: boolean = true;
  errorMessage: string = '';
  showImportantDates = false;
  clocks: any[] = [];
  stage?: any;
  showClientInfo: boolean = false;

  activeForm: string = 'doc-order';
  showDocument: string = 'public';

  isMarkedAsReceived: boolean = false;
  hasMadeInitialGet: boolean = false;
  isUpdating: boolean = false;

  offerFile: File | null = null;
  offerUploading = false;
  offerUploadError = '';

  private readonly OFFER_EXTENSIONS = ['pdf','jpg','jpeg','png','csv','txt','docx','doc','xls','xlsx','zip','rar'];
  private readonly OFFER_MAX_SIZE = 15 * 1024 * 1024; // 15MB

  btn_fast_actions = false;
  back = '';
  next_ok = '';
  next_ko = '';
  role: any;

  step: number = 1;
  clientFormExtra: FormGroup = new FormGroup({});

  constructor(
    private route: ActivatedRoute,
    private orderService: OrdersService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private fb2: FormBuilder,
  ) {
    this.clientFormExtra = this.fb2.group({
      client_gender: [null, Validators.required],
      client_marital_status: [null, Validators.required],
      client_housing_type: [null, Validators.required],
      client_monthly_net_income: [null, Validators.required],
      client_employment_situation: [null, Validators.required],
      client_employer_name: [null, Validators.required],
      client_employer_tax_id: [null, Validators.required],
      client_employer_from_date: [null, Validators.required],
      client_employer_address: [null, Validators.required],
      client_employer_postal_code: [null, Validators.required],
      client_bank_account: [null, Validators.required],
    });
  }

  ngOnInit() {
    this.loadPublicOrder();
  }

  setVariables() {
    this.stage = this.orderData?.stage;
  }

  getOrderPublicDocuments(): any[] {
    if (!this.orderData?.documents) return [];
    return this.orderData.documents.filter(
      (doc: any) => doc.visibility === 'public'
    );
  }

  getClientPublicDocuments(): any[] {
    if (!this.orderData?.client?.documents) return [];
    return this.orderData.client.documents.filter(
      (doc: any) => doc.visibility === 'public'
    );
  }
 //OTHER FUNCTIONS
  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }
  loadPublicOrder() {
    this.route.params.subscribe((params) => {
      const reference = params['reference'];
      this.route.queryParams.subscribe((queryParams) => {
        const token = queryParams['token'];

        this.orderService.getPublicOrder(reference, token).subscribe({
          next: (response: any) => {
            this.orderData = response.data;
            if (this.orderData) {
              this.clientFormExtra.patchValue(this.orderData);
            }
            this.updateFieldAccessibility();
            this.setVariables();
            this.isLoading = false;
            this.hasMadeInitialGet = true;

            if (this.isSentStage()) {
              this.showClientInfo = false;
            } else {
              this.showClientInfo = true;
            }
          },
          error: (error: any) => {
            console.error('Error:', error);
            this.isLoading = false;
            this.errorMessage = this.getErrorMessage(error);
          },
        });
      });
    });
  }

  isClientInputDisabled: boolean = true;

  updateFieldAccessibility() {
    var rules = this.orderData?.rules;
    for (const field in this.clientFormExtra.controls) {
      if (this.clientFormExtra.controls.hasOwnProperty(field)) {
        this.clientFormExtra.get(field)?.disable();
      }
    }
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.clientFormExtra.get(field)?.enable();
      }
    }
    this.isClientInputDisabled =
      this.clientFormExtra.get('client_id')?.disabled ?? false;
  }

  getStageText(): string {
    const stageMap: any = {
      offer_pending: 'Oferta Pendiente',
      offer_requested: 'Oferta Solicitada',
      offer_created: 'Oferta Creada',
      offer_sent: 'Oferta Enviada',
      sent: 'Enviado',
      received: 'Recibido',
      completed: 'Completado',
      rejected: 'Rechazado',
      uncompleted: 'Incompleto',
    };
    return (
      stageMap[this.orderData?.stage] || this.orderData?.stage || 'Desconocido'
    );
  }

  isSentStage(): boolean {
    return (
      this.orderData?.stage === 'sent' || this.orderData?.stage === 'offer_sent'
    );
  }

  toggleClientInfo() {
    if (this.isSentStage() && !this.isMarkedAsReceived) {
      this.markAsReceived();
    } else {
      this.showClientInfo = !this.showClientInfo;
    }
  }

  shouldShowInitialMessage(): boolean {
    return this.isSentStage() && !this.isMarkedAsReceived;
  }

  shouldShowDocuments(): boolean {
    return !this.isSentStage() || this.isMarkedAsReceived;
  }

  getErrorMessage(error: any): string {
    if (error.status === 410) {
      return 'Este enlace ya ha sido utilizado';
    } else if (error.status === 404) {
      return 'El enlace ha expirado o es inválido';
    } else {
      return this.translateService.instant('swal_messages.error_order');
    }
  }

  getClientTitle(): string {
    if (!this.orderData?.client) return '';

    if (this.orderData.client.type === 'organization') {
      return this.translateService.instant('inputs.organization_responsible');
    } else {
      return this.translateService.instant('inputs.client_titular');
    }
  }

  getButtonText(): string {
    if (this.isSentStage() && !this.showClientInfo) {
      return 'buttons.download_document';
    } else if (this.showClientInfo) {
      return 'buttons.hide_documents';
    } else {
      return 'buttons.show_documents';
    }
  }

  getInitialMessage(): string {
    if (this.isSentStage()) {
      return 'inputs.confirm_reception_message';
    } else {
      return 'inputs.download_documentation_message';
    }
  }

  handleButtonAction() {
    if (this.isSentStage() && !this.isMarkedAsReceived) {
      this.markAsReceived();
    } else {
      this.showClientInfo = !this.showClientInfo;
    }
  }

  hasOrderDocuments(): boolean {
    if (!this.orderData?.documents) return false;
    return this.orderData.documents.length > 0;
  }

  hasClientDocuments(): boolean {
    if (!this.orderData?.client?.documents) return false;
    return this.orderData.client.documents.length > 0;
  }

  hasGuaranteeDocuments(): boolean {
    if (!this.orderData?.guarantee?.documents) return false;
    return this.orderData.guarantee.documents.length > 0;
  }

  hasAnyDocuments(): boolean {
    return (
      this.hasOrderDocuments() ||
      this.hasClientDocuments() ||
      this.hasGuaranteeDocuments()
    );
  }

  isOfferPending(): boolean {
    return this.orderData?.stage === 'offer_pending';
  }

  isOfferRequested(): boolean {
    return this.orderData?.stage === 'offer_requested';
  }

  viewClientData(): void {
    const reference = this.route.snapshot.params['reference'];
    const token = this.route.snapshot.queryParams['token'];
    this.alertService.loading('swal_messages.please_wait');
    this.orderService.updatePublicOrder(reference, token, { stage: 'offer_requested' }).subscribe({
      next: () => {
        this.loadPublicOrder(); // reload to get fresh token + new stage
      },
      error: (err: any) => {
        this.alertService.error(this.getErrorMessage(err));
      },
    });
  }

  onOfferFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    const file = input.files[0];
    this.offerUploadError = '';

    const ext = file.name.split('.').pop()?.toLowerCase() || '';
    if (!this.OFFER_EXTENSIONS.includes(ext)) {
      this.offerUploadError = this.translateService.instant('swal_messages.documents.invalid_extension');
      this.offerFile = null;
      return;
    }
    if (file.size > this.OFFER_MAX_SIZE) {
      this.offerUploadError = this.translateService.instant('swal_messages.documents.file_too_large');
      this.offerFile = null;
      return;
    }
    this.offerFile = file;
  }

  uploadOffer(): void {
    if (!this.offerFile) return;
    const reference = this.route.snapshot.params['reference'];
    const token = this.route.snapshot.queryParams['token'];
    this.offerUploading = true;
    this.offerUploadError = '';

    this.orderService.uploadPublicDocument(reference, token, this.offerFile).subscribe({
      next: (res: any) => {
        this.offerUploading = false;
        this.offerFile = null;
        this.alertService.successOk('swal_messages.documents.document_created');
        if (res.data?.stage_advanced) {
          this.loadPublicOrder();
        }
      },
      error: (err: any) => {
        this.offerUploading = false;
        if (err.error?.errors?.documents?.[0]?.msg) {
          this.alertService.error(err.error.errors.documents[0].msg);
        } else if (err.error?.error) {
          this.alertService.error(err.error.error);
        } else {
          this.alertService.error('swal_messages.error');
        }
      },
    });
  }

  markAsReceived() {
    this.isUpdating = true;
    const reference = this.route.snapshot.params['reference'];
    const token = this.route.snapshot.queryParams['token'];

    const updateData = {
      stage: 'received',
    };
    this.alertService.loading('swal_messages.please_wait');
    this.orderService
      .updatePublicOrder(reference, token, updateData)
      .subscribe({
        next: (response: any) => {
          this.isUpdating = false;
          this.isMarkedAsReceived = true;
          this.showClientInfo = true;

          if (this.orderData) {
            this.orderData.stage = 'received';
            this.stage = 'received';
          }

          this.alertService.success('swal_messages.order_updated');
        },
        error: (error: any) => {
          this.isUpdating = false;

          if (error.status === 410) {
            this.alertService.error(
              'Este enlace ya ha sido utilizado para actualizar'
            );
          } else if (error.status === 404) {
            this.alertService.error('El enlace ha expirado o es inválido');
          } else {
            this.alertService.error('swal_messages.order_status_error');
          }
        },
      });
  }
}
